import React, { Component } from "react";
import "./ProductoModal.css";
import { toast } from "react-toastify";

export default class ProductoModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(props);
  }

  getInitialState = (props) => {
    const { mode = "create", producto } = props || {};

    if (mode === "edit" && producto) {
      return {
        sku: producto?.sku ?? "",
        producto: producto?.producto ?? "",
        clave_sat: producto?.clave_sat ?? "",
        idestatus: producto?.idestatus ?? 1,
      };
    }

    return {
      sku: "",
      producto: "",
      clave_sat: "",
      idestatus: 1,
    };
  };

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const modeChanged = prevProps.mode !== this.props.mode;

    const prevId = prevProps?.producto?.idproducto;
    const nextId = this.props?.producto?.idproducto;

    if (openedNow || modeChanged || (this.props.show && prevId !== nextId)) {
      this.setState(this.getInitialState(this.props));
    }
  }

  setField = (key, value) => {
    this.setState({ [key]: value });
  };

  setEstatus = (v) => {
    this.setState({ idestatus: v });
  };

  validateAndBuildPayload = () => {
    const sku = String(this.state.sku || "").trim();
    const producto = String(this.state.producto || "").trim();
    const clave_sat = String(this.state.clave_sat || "").trim();
    const idestatus = Number(this.state.idestatus || 0);

    if (!sku) return { ok: false, message: "SKU requerido." };
    if (!producto) return { ok: false, message: "Producto requerido." };
    if (!clave_sat) return { ok: false, message: "Clave SAT requerida." };

    // regla práctica: 8 dígitos numéricos (ajústala si tu backend acepta otra cosa)
    if (!/^\d{8}$/.test(clave_sat)) {
      return { ok: false, message: "Clave SAT debe ser numérica de 8 dígitos." };
    }

    if (![1, 2].includes(idestatus)) {
      return { ok: false, message: "Selecciona Activo o Inactivo." };
    }

    return {
      ok: true,
      payload: { sku, producto, clave_sat, idestatus },
    };
  };

  onSubmit = () => {
    const r = this.validateAndBuildPayload();
  
    if (!r.ok) {
      toast.info(r.message || "Verifica los campos.");
      return;
    }
  
    this.props?.onSave?.(r.payload);
  };
  

  render() {
    const { show, onClose, loading, mode = "create" } = this.props;
    const { sku, producto, clave_sat, idestatus } = this.state;

    if (!show) return null;

    const title = mode === "edit" ? "Editar producto" : "Agregar producto";
    const btnText = mode === "edit" ? "ACTUALIZAR" : "ACEPTAR";

    return (
      <div className="pm-backdrop" >
        <div className="pm-modal pm-narrow" onClick={(e) => e.stopPropagation()}>
          <div className="pm-head">
            <h3 className="pm-title">{title}</h3>
            <button className="pm-x" onClick={loading ? null : onClose} aria-label="Cerrar">
              ✕
            </button>
          </div>

          <div className="pm-body">
            <div className="pm-field">
              <label>SKU *</label>
              <input
                value={sku}
                onChange={(e) => this.setField("sku", e.target.value)}
                placeholder="SKU001"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Producto *</label>
              <input
                value={producto}
                onChange={(e) => this.setField("producto", e.target.value)}
                placeholder="Producto 1"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Clave SAT *</label>
              <input
                value={clave_sat}
                onChange={(e) => this.setField("clave_sat", e.target.value)}
                placeholder="01010101"
                inputMode="numeric"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Estatus *</label>
              <div className="pm-toggle">
                <button
                  type="button"
                  className={`pm-pill ${Number(idestatus) === 1 ? "active" : ""}`}
                  onClick={() => this.setEstatus(1)}
                  disabled={loading}
                >
                  Activo
                </button>
                <button
                  type="button"
                  className={`pm-pill ${Number(idestatus) === 2 ? "active" : ""}`}
                  onClick={() => this.setEstatus(2)}
                  disabled={loading}
                >
                  Inactivo
                </button>
              </div>
            </div>



          </div>

          <div className="pm-foot pm-footCenter">
            <button className="pm-btn ghost" onClick={onClose} disabled={loading}>
              CANCELAR
            </button>
            <button className="pm-btn" onClick={this.onSubmit} disabled={loading}>
              {btnText}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
